import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "tiercreator" */
        '../redux/creator/ModuleLoadable'
      )
  )
);

const LoadableTierPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "tierpopup" */
        './TierPopup'
      )
  )
);

interface Props {
  deviation?: PapiDeviation;
  requestClose: () => void;
}

const LazyTierPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyTierPopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}>
      <LoadableRedux />
      <LoadableTierPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyTierPopup.displayName = 'LazyTierPopup';

export default LazyTierPopup;
